import React from "react";
import CustomModal from "../../common/CustomModal";
import AdRequestCreate from "../../AdRequest/AdRequestCreate";

/** Agency creates the request and delivers its hooks in one submit; QC is passed on save. */
const DirectDeliveryModal = ({ open, onClose }) => (
  <CustomModal
    open={open}
    title="Deliver without request"
    onClose={onClose}
    isButtonsRequired={false}
    bodyClassName="bg-[#f7f7fb]"
    className="md:!w-[92%] lg:!w-[80%]"
  >
    <AdRequestCreate direct onSuccess={onClose} />
  </CustomModal>
);

export default DirectDeliveryModal;
